import { CSSProperties } from 'react'
import { Button } from './Button'
import { Info } from './Info'

export interface Props {
  style?: CSSProperties
}

export const CallCenter = {
  Button,
  Info
}
